import $ from 'jquery'
import _ from 'lodash'
import features from './features'
import url from './url'

const defaultUrl = features.browser ? window.location.origin + window.location.pathname : ''
let baseUrl = defaultUrl

/**
 * If a request is being made for a shared dashboard this will be assigned
 * inside of start.js and passed to initialize.  This allows all dashboard requests
 * to be authenticated even if third-party cookies are disabled and the capability
 * to have a single shared session doesn't exist.
 *
 * Note that AvailableResourceFilter.readEmbeddedResourceToken will only read
 * this token and perform an authentication if a user is not already logged into
 * the session.
 */
let embeddedToken

/**
 * A centralized function to create a correct scoreboard url from the baseUrl
 * and a relative path. Note this is NOT for use in conjunction with
 * sp-navigate. When working with sp-navigate you should only specify the
 * route, e.g. dashboards/3. No http or anything should be included there
 *
 * @param relativeUrl
 * @param {Boolean} [options.ignoreToken=false] Pass true to skip adding the
 * embeddedToken parameter
 *
 * @returns {*}
 */
function scoreboardUrl (relativeUrl, options={}) {
	let trimmed = baseUrl + _.trimStart(relativeUrl, '/')
	if (!options.ignoreToken && embeddedToken) {
		const {pathname, query} = url.parse(trimmed, true)
		return pathname + '?'
			+ $.param(_.extend({}, query, {embeddedToken}))
	} else {
		return trimmed
	}
}

/**
 * Get the base url (domain and context) e.g. `http://localhost:8080/cms`
 * Must NOT be used to construct urls, use scoreboardUrl for that
 * @returns {string}
 */
function getBaseUrl () {
	return baseUrl
}

/**
 * Allows start.js to set the proper baseUrl, not intended to be called elsewhere
 */
function initialize ({baseUrl: url, embeddedToken: token}) {
	baseUrl = url
	embeddedToken = token
}

/**
 * For tests to reset to the default global state
 */
function reset () {
	baseUrl = defaultUrl
	embeddedToken = undefined
}

_.extend(scoreboardUrl, {
	getBaseUrl,
	initialize,
	reset
})
export default scoreboardUrl
export { getBaseUrl, initialize, reset }
scoreboardUrl.__filename__ = 'components/scoreboard-url.js'
